var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRightGroup = function SvgRightGroup(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 827,
    height: 1387,
    viewBox: "0 0 827 1387",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "20.438%",
    x2: "79.091%",
    y1: "27.328%",
    y2: "82.497%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A175E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#985CD6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M361.625 105.342c-59.103 74.121-15.66 199.247-194.18 247.806C-11.076 401.707-28.88 564.001 30.825 668.105c59.706 104.105 208.283 138.36 314.578 106.62 78.45-23.426 106.244-81.763 192.472-137.938 86.229-56.174 91.955-41.454 204.136-113.186 74.058-47.355 87.309-142.517 84.127-192.635C815.469 162.901 688.604.741 546.714.755c-61.623.007-126.096 30.602-185.089 104.587"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "20.438%",
    x2: "79.091%",
    y1: "43.668%",
    y2: "59.077%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A175E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#985CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "20.438%",
    x2: "79.091%",
    y1: "34.937%",
    y2: "71.591%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A175E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#985CD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "-.544%",
    x2: "96.657%",
    y1: "75.589%",
    y2: "26.644%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D82DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#33C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "3.321%",
    x2: "119.19%",
    y1: "134.664%",
    y2: "61.655%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D82DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#33C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "3.321%",
    x2: "119.19%",
    y1: "91.239%",
    y2: "55.677%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2D82DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#33C4FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M98.677 738.994c71.443 47.186 170.08 58.618 246.726 35.731 78.45-23.426 106.244-81.763 192.472-137.938 51.646-33.645 74.413-41.858 108.47-58.446-59.199-42.239-132.639-67.244-212.191-67.244-155.238 0-287.207 95.218-335.477 227.897",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M546.714.755C485.09.762 420.618 31.357 361.625 105.342c-59.103 74.121-15.66 199.247-194.18 247.806-15.952 4.339-30.621 9.587-44.066 15.619 53.162 30.331 115.31 47.755 181.719 47.755 196.114 0 355.096-151.978 355.096-339.452 0-14.692-.974-29.153-2.868-43.353C622.945 12.799 585.391.757 546.732.755h-.018",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M1.248 340.054c8.684 131.842 185.087 114.455 236.023-31.068 22.788-65.106 50.041-34.962 144.11-93.848C481.948 152.183 410.063 6.661 343.534 1.504A434.911 434.911 0 0 0 309.988.185C109.302.174-11.526 146.147 1.248 340.054",
    transform: "translate(32 957.467)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M313.76 183.625c-121.828 13.243-210.902 99.791-198.951 193.31 2.044 15.999 6.914 31.171 14.192 45.256 44.789-14.493 88.93-53.725 109.178-115.924 23.034-70.76 39.967-34.779 135.764-86.688 15.603-8.455 27.589-18.642 36.477-29.925-20.609-5.043-42.552-7.74-65.24-7.739-10.332 0-20.832.559-31.42 1.71",
    transform: "translate(32 957.467)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M29.104 169.951c40.654 18.994 90.214 27.607 142.197 21.956 116.222-12.632 202.634-91.97 199.966-180.439-9.085-5.715-18.511-9.249-27.733-9.964A434.905 434.905 0 0 0 309.989.185C174.344.178 75.188 66.85 29.104 169.951",
    transform: "translate(32 957.467)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRightGroup);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/right-group.2cb11418f0c4d47a014f6b9081fc7b4a.svg";